/* global YT */

let youtubeAPIReady = false;
let youtubeAPIReadyCallbacks = [];

export function loadYouTubeIframeAPI(callback) {
    if (youtubeAPIReady) {
        callback();
    } else {
        youtubeAPIReadyCallbacks.push(callback);
        if (typeof YT === 'undefined' || !window.YT) {
            const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
            if (!existingScript) {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
            window.onYouTubeIframeAPIReady = () => {
                youtubeAPIReady = true;
                youtubeAPIReadyCallbacks.forEach((cb) => cb());
                youtubeAPIReadyCallbacks = [];
            };
        }
    }
}

export function initYouTubePlayer(youtubeContainer) {
    const youtubeId = youtubeContainer.dataset.youtubeId;
    const isHeroPlayer = youtubeContainer.id === 'hero-youtube-player';

    const player = new YT.Player(youtubeContainer, {
        host: 'https://www.youtube-nocookie.com',
        videoId: youtubeId,
        playerVars: {
            playsinline: 1,
            autoplay: isHeroPlayer ? 1 : 0,
            mute: isHeroPlayer ? 1 : 0,
            loop: 1,
            rel: 0,
            modestbranding: 1,
        },
        events: {
            onReady: () => {
                if (isHeroPlayer) {
                    player.playVideo();
                }
            },
        },
    });

    return player;
}
